var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoublearrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0703 14.1016C13.8594 14.3125 13.8594 14.6641 14.0703 14.875L18.6172 19.4453C18.8516 19.6562 19.2031 19.6562 19.4141 19.4453L19.9531 18.9062C20.1641 18.6953 20.1641 18.3437 19.9531 18.1094L16.3438 14.5L19.9531 10.8672C20.1641 10.6328 20.1641 10.2812 19.9531 10.0703L19.4141 9.53125C19.2031 9.32031 18.8516 9.32031 18.6172 9.53125L14.0703 14.1016Z",
    fill: "#363ED3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07031 14.1016C8.85938 14.3125 8.85938 14.6641 9.07031 14.875L13.6172 19.4453C13.8516 19.6562 14.2031 19.6562 14.4141 19.4453L14.9531 18.9062C15.1641 18.6953 15.1641 18.3437 14.9531 18.1094L11.3438 14.5L14.9531 10.8672C15.1641 10.6328 15.1641 10.2812 14.9531 10.0703L14.4141 9.53125C14.2031 9.32031 13.8516 9.32031 13.6172 9.53125L9.07031 14.1016Z",
    fill: "#363ED3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoublearrowLeft);
export default __webpack_public_path__ + "static/media/icon-doublearrow-left.0296054aee529a0be26b75dfa5139b8e.svg";
export { ForwardRef as ReactComponent };